jQuery(document).ready(function ($) {
	jQuery('.table-anchor>img').each(function (i) {
		jQuery(this).parent().css('max-width', jQuery(this).attr('width') + 'px');
	});

	$('body').on('click', '.exit',function (e) {
		e.preventDefault();
		$(this).closest('.overlay').hide();
	});

	jQuery(".retinaCards").each(function () {
		var image = jQuery(this);
		var src = image.attr("src");
		var src2x = image.data("src2x");
		var src3x = image.data("src3x");

		if (window.devicePixelRatio > 2 && src3x) {
			src = src3x;
		} else if (window.devicePixelRatio > 1 && src2x) {
			src = src2x;
		}

		image.attr("src", src);
	});

	//Show more TOC

	var tocContent = $('.toc-content');
    var tocToggle = $('.toc-toggle');

	// console.log(tocContent.height());

    if (tocContent.height() > 200) {
        tocToggle.show();
        tocContent.addClass('restricted');
        tocContent.find('::after').css('display', 'block');
    }

    // Toggle functionality
    tocToggle.on('click', function() {
        var isExpanded = tocContent.hasClass('expanded');
        var isRestricted = tocContent.hasClass('restricted');
        tocContent.toggleClass('expanded');
        $(this).toggleClass('expanded');

        // Toggle gradient and button text
        if (isExpanded) {
			if(!isRestricted) {
				tocContent.addClass('restricted');
				tocToggle.text('Show More');
				tocContent.find('::after').css('display', 'block');
				$('.toc-toggle:before').css('opacity', '1');
			}
        } else {
            tocContent.removeClass('restricted');
            tocToggle.text('Show Less');
            $('.toc-toggle:before').css('opacity', '0');
        }
    });

	// Remove default input

	let inputFields = document.querySelectorAll('input[name^="question["]');

	inputFields.forEach(function(inputField) {
		inputField.addEventListener('keydown', function(event) {
			if (event.key === 'Enter' || event.keyCode === 13) {
				// Prevent form submission
				event.preventDefault();
			}
		});
	});

	// Convert anchor tags with `tooltip-trigger` and class and specific href to spans
	$('a.tooltip-trigger').each(function () {
		const href = $(this).attr('href');
		if (href && href.startsWith('/terms/')) {
			const tooltipContent = $(this).find('.tooltip-content');
			const text = $(this).text();
			const span = $('<span>')
				.addClass($(this).attr('class'))
				.attr('data-tooltip', $(this).attr('data-tooltip'))
				.text(text);
			span.append(tooltipContent);
			$(this).replaceWith(span);
		}
	});

	$('.tooltip-trigger').hover(function () {
		if (this.id !== 'authorTooltip' && $(window).width() <= 1024) {
			return;
		}
		if (!$(this).closest('.tooltip-content').length) {
			$('#' + $(this).attr('data-tooltip')).appendTo($(this)).css('pointer-events', 'auto').fadeIn();
		}
	}, function () {
		$(this).find('.tooltip-content').css('pointer-events', 'none').hide();
	})


	// Topic Outline Join tooltips
	new jBox('Tooltip', {
		attach: '.not-trackable .check, span.not-trackable, .mark-complete.not-trackable>a, .buy-now.not-upgradeable',
		adjustPosition: true,
		zIndex: 9999,
		addClass: 'tooltip-join',
		position: {
			x: 'center',
			y: 'top'
		},
		offset: {
			y: 20
		},
		content: $('#topicOutlineJoin')
	});

	new jBox('Tooltip', {
		attach: '.buy-now.not-upgradeable-plus',
		adjustPosition: true,
		zIndex: 9999,
		addClass: 'tooltip-join',
		position: {
			x: 'center',
			y: 'top'
		},
		offset: {
			y: 20
		},
		content: $('#topicOutlineJoinPlus')
	});

	new jBox('Tooltip', {
		attach: '.coaching-toggle.non-member',
		adjustPosition: true,
		zIndex: 9999,
		addClass: 'tooltip-join',
		position: {
			x: 'center',
			y: 'top'
		},
		offset: {
			y: 20
		},
		content: $('#wordScrambleJoin')
	});

	// Badge hover tooltips
	new jBox('Tooltip', {
		attach: '.badge:not(.certificate-image .badge)',
		adjustPosition: true,
		zIndex: 9,
		addClass: 'tooltip-badge',
		position: {
			x: 'center',
			y: 'bottom'
		},
		getTitle: 'data-badge-title',
		getContent: 'data-badge-content',
	});

	// Question hover tooltips
	new jBox('Tooltip', {
		attach: '.questionmark',
		adjustPosition: true,
		zIndex: 9,
		addClass: 'tooltip-question',
		position: {
			x: 'center',
			y: 'top'
		},
		getTitle: 'data-badge-title',
		getContent: 'data-badge-content',
	});

	new jBox('Tooltip', {
		attach: '.img-container:not(.certificate-image .img-container)',
		adjustPosition: true,
		zIndex: 9,
		addClass: 'tooltip-badge',
		position: {
			x: 'center',
			y: 'bottom'
		},
		getTitle: 'data-badge-title',
		getContent: 'data-badge-title',
	});


	// Comparison Table
	$('.comparison-table__header').on('click', function () {
		$('.comparison-table__column').removeClass('comparison-table__column--active');
		$(this).parent().addClass('comparison-table__column--active');
	});

	// Purchase Table
	if ($(window).width() <= 1023) {
        $('.purchase-table__header .purchase-table__column').on('click', function () {
            $('.purchase-table__column').removeClass('purchase-table__column--active');

            $(this).addClass('purchase-table__column--active');
            $('.purchase-table__column--pro').hide();
            $('.purchase-table__column--plus').hide();
			$('.purchase-table__buttons-mobile a.button').hide();

            $('.purchase-table__column--' + $(this).attr('data-type')).show();
            $('.purchase-table__buttons-mobile a.button--' + $(this).attr('data-type')).show();
        });
    }

	$('#mobile-team-menu').on('click', function () {
		if (!$(this).hasClass('is-active')) {
			$('.attic').addClass('attic--mobile-open');
		}
		$(this).toggleClass('is-active');

		$('#sidebar').toggleClass('open');
		$('#team-dashboard').toggleClass('menu-open');

	});


	$('#mobile-menu').on('transitionend webkitTransitionEnd oTransitionEnd', function () {

		if (!$('#mobile-menu').hasClass('mobile-menu--open')) {
			$('.attic').removeClass('attic--mobile-open');
		}

	});

	$('#sidebar').on('transitionend webkitTransitionEnd oTransitionEnd', function () {

		if (!$('#sidebar').hasClass('open')) {
			$('.attic').removeClass('attic--mobile-open');
		}

	});

	$('#mobile-search-toggle').on('click', function () {
		$(this).toggleClass('is-active');
		$('#mobile-site-search').toggleClass('mobile-search--open');
	});


	// Member menu
	$('#member-menu-toggle').hover(function () {
		$('#member-menu').addClass('is-active');
	});

	$('#member-menu').mouseleave(function () {
		$('#member-menu').removeClass('is-active');

	});

	// Scroll to hash if matching element exists
	var hash = '#' + $(location).attr('href').split('#')[1];
	var target = $(hash);
	// Does a scroll target exist?
	if (target.length) {
		$('html, body').animate({
			scrollTop: target.offset().top - 100
		}, 1000);
	}

	// Smooth scrolling to anchors
	$('a[href*="#"]')
		.not('[href="#"]')
		.not('[href="#_"]')
		.click(function (event) {
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var scrollOffset = 100;
				if(this.hash == '#toc') {
					scrollOffset = 200;
				}

				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top - scrollOffset
					}, 1000);
				}
			}
		});

	let topicFilter = '';
	let topicOrder = getCookie("order_archive");
	if (topicOrder == '') {
		topicOrder = 'recommended';
	}

	$('button[name="flashcards-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--flashcards').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#flashcards span.count-number").hide();
		} else {
			$('.button-two--flashcards').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#flashcards span.count-number").show();
		}
		updateDownloadTopics('flashcards');
	});

	$('button[name="cheatsheets-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--cheatsheets').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#cheat-sheets span.count-number").hide();
		} else {
			$('.button-two--cheatsheets').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#cheat-sheets span.count-number").show();
		}
		updateDownloadTopics('cheatsheets');
	});

	$('button[name="crosswords-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--crosswords').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#crossword-puzzles span.count-number").hide();
		} else {
			$('.button-two--crosswords').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#crossword-puzzles span.count-number").show();
		}
		updateDownloadTopics('crossword-puzzles');
	});

	$('button[name="explanations-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--explanations').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#explanations span.count-number").hide();
		} else {
			$('.button-two--explanations').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#explanations span.count-number").show();
		}
		updateDownloadTopics('explanations');
	});

	$('button[name="tests-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--tests').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#tests span.count-number").hide();
		} else {
			$('.button-two--tests').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#tests span.count-number").show();
		}
		updateDownloadTopics('tests');
	});

	$('button[name="visual-tutorials-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--visual-tutorials').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#visual-tutorials span.count-number").hide();
		} else {
			$('.button-two--visual-tutorials').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#visual-tutorials span.count-number").show();
		}
		updateDownloadTopics('visual-tutorials');
	});

	$('button[name="word-scrambles-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--word-scrambles').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#word-scrambles span.count-number").hide();
		} else {
			$('.button-two--word-scrambles').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#word-scrambles span.count-number").show();
		}
		updateDownloadTopics('word-scrambles');
	});

	$('button[name="quiz-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--quiz').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#quizzes span.count-number").hide();
		} else {
			$('.button-two--quiz').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#quizzes span.count-number").show();
		}
		updateDownloadTopics('quizzes');
	});

	$('button[name="word-searches-order-select"]').on('click', function () {
		topicOrder = $(this).val();
		$(this).addClass('btn-selected');
		if (topicOrder === 'alphabetical') {
			$('.button-one--word-searches').removeClass('btn-selected');
			$('table.recommended').addClass('alphabetical');
			setCookieOrder('order_archive', 'alphabetical', 10);
			$("#word-searches span.count-number").hide();
		} else {
			$('.button-two--word-searches').removeClass('btn-selected');
			$('table.recommended').removeClass('alphabetical');
			setCookieOrder('order_archive', 'recommended', 10);
			$("#word-searches span.count-number").show();
		}
		updateDownloadTopics('word-searches');
	});

	function updateDownloadTopics(tablename) {
		let listContainer = $('table.recommended.' + tablename);
		var $fields, sorted;

		$fields = $('table.recommended.' + tablename + " tr.sorted");
		sorted = [];
		let unsorted = []
		$fields.detach().each(function () {
			if (topicOrder === 'recommended') {
				if (this.getAttribute("data-" + (topicFilter || 'default') + "-order")) {
					sorted[parseInt(this.getAttribute("data-" + (topicFilter || 'default') + "-order"), 10)] = this;
				} else {
					unsorted.push(this);
				}
			} else {
				if (this.getAttribute("data-alphabetical")) {
					sorted[parseInt(this.getAttribute("data-alphabetical"), 10)] = this;
				} else {
					unsorted.push(this);
				}
			}

		});
		sorted = [...sorted, ...unsorted];
		sorted.forEach(function (element) {
			listContainer.append(element);
		});
	}

	$('#sidebar-order-select').on('change', function () {
		topicOrder = $(this).val();
		if (topicOrder === 'alphabetical') {
			$('#tsb-topics ol.recommended').addClass('alphabetical');
		} else {
			$('#tsb-topics ol.recommended').removeClass('alphabetical');
		}
		updateSidebarTopics();
	});


	$('#sidebar-category-select').on('change', function () {
		topicFilter = $(this).val();
		if (topicOrder === 'alphabetical') {
			$('#tsb-topics ol.recommended').addClass('alphabetical');
		} else {
			$('#tsb-topics ol.recommended').removeClass('alphabetical');
		}
		updateSidebarTopics();
	});


	// $(window).on('load', function() {
	// 	topicFilter = getCookie("topic");
	// 	topicOrder = getCookie("order");
	// 	$('#sidebar-category-select').val(topicFilter);
	// 	$('#sidebar-order-select').val(topicOrder);
	// 	$('#sidebar-order-select').trigger('change');
	// });

	function initSortingAndFiltering() {
		topicFilter = getCookie("topic");
		topicOrder = getCookie("order_archive");

		// Set the value of the select elements according to the cookies
		$('#sidebar-category-select').val(topicFilter);
		$('#sidebar-order-select').val(topicOrder);
		if (topicOrder == '') {
			topicOrder = 'recommended';
		}
		// Update the class of the list based on the topicOrder value
		if (topicOrder === 'alphabetical') {
			$('#tsb-topics ol.recommended').addClass('alphabetical');
		} else {
			$('#tsb-topics ol.recommended').removeClass('alphabetical');
		}

		// Update the sidebar topics based on the selected values
		updateSidebarTopics();
	}

	initSortingAndFiltering();


	function updateSidebarTopics() {
		let listContainer = $('#tsb-topics ol.recommended');
		var $fields, sorted;

		$fields = $("#tsb-topics ol.recommended li.sorted");
		sorted = [];
		let unsorted = []
		$fields.detach().each(function () {
			if (topicOrder === 'recommended') {
				if (this.getAttribute("data-" + (topicFilter || 'default') + "-order")) {
					const newIndex = parseInt(this.getAttribute("data-" + (topicFilter || 'default') + "-order"), 10);
					if(!sorted[newIndex]) {
						sorted[newIndex] = [];
					}
					sorted[newIndex].push(this);
				} else {
					unsorted.push(this);
				}
			} else {
				if (this.getAttribute("data-" + (topicOrder || 'alphabetical'))) {
					const newIndex = parseInt(this.getAttribute("data-" + (topicOrder || 'alphabetical')), 10);
					if(!sorted[newIndex]) {
						sorted[newIndex] = [];
					}
					sorted[newIndex].push(this);
				} else {
					unsorted.push(this);
				}
			}

		});
		let shownIndex = 1;
		sorted = [...sorted, ...unsorted];
		sorted.forEach(function (element) {
			if(Array.isArray(element)){
				element.forEach(function (subElement) {
					listContainer.append(subElement);
					if (!$(subElement).find('a').text()) {
						return;
					}
					if (topicFilter) {
						if (!!$(subElement).attr('data-category') && $(subElement).attr('data-category').includes(topicFilter)) {
							$(subElement).show()
							let orderNum = '0' + shownIndex
							$(subElement).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
							shownIndex++;
						} else {
							$(subElement).hide();
						}
					} else {
						$(subElement).show()
						let orderNum = '0' + shownIndex
						$(subElement).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
						shownIndex++;
					}
				});
			}else {
				listContainer.append(element);
				if (!$(element).find('a').text()) {
					return;
				}
				if (topicFilter) {
					if (!!$(element).attr('data-category') && $(element).attr('data-category').includes(topicFilter)) {
						$(element).show()
						let orderNum = '0' + shownIndex
						$(element).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
						shownIndex++;
					} else {
						$(element).hide();
					}
				} else {
					$(element).show()
					let orderNum = '0' + shownIndex
					$(element).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
					shownIndex++;
				}
			}
		});
	}


	let mainTopicFilter = '';
	let mainTopicOrder = '';


	$(window).load(function () {
		mainTopicOrder = getCookie("order_archive");
		if(mainTopicOrder) {
			$('#all-topic-order-select').val(mainTopicOrder);
			$('#all-topic-order-select').trigger('change');
		}
	});

	$('#all-topic-order-select').on('change', function () {
		mainTopicOrder = $(this).val();
		if (mainTopicOrder === 'alphabetical') {
			$('#main-outline-topics ol.recommended').addClass('alphabetical');
		} else {
			$('#main-outline-topics ol.recommended').removeClass('alphabetical');
		}
		updateMainTopicOutline();
	});
	$('#all-topic-category-select').on('change', function () {
		mainTopicFilter = $(this).val();
		updateMainTopicOutline();
	});

	function updateMainTopicOutline() {
		let listContainer = $('#main-outline-topics ol.recommended');
		var $fields, sorted;

		$fields = $("#main-outline-topics ol.recommended li.sorted");
		sorted = [];
		let unsorted = []
		$fields.detach().each(function () {
			if (mainTopicOrder === 'recommended') {
				if (this.getAttribute("data-" + (mainTopicFilter || 'default') + "-order")) {
					sorted[parseInt(this.getAttribute("data-" + (mainTopicFilter || 'default') + "-order"), 10)] = this;
				} else {
					unsorted.push(this);
				}
			} else {
				if (this.getAttribute("data-alphabetical")) {
					sorted[parseInt(this.getAttribute("data-alphabetical"), 10)] = this;
				} else {
					unsorted.push(this);
				}
			}

		});
		let shownIndex = 1;
		sorted = [...sorted, ...unsorted];
		sorted.forEach(function (element) {
			listContainer.append(element);
			if (!$(element).find('a').text()) {
				return;
			}
			if (mainTopicFilter) {
				if (!!$(element).attr('data-category') && $(element).attr('data-category').includes(mainTopicFilter)) {
					$(element).show()
					let orderNum = '0' + shownIndex
					$(element).find('.list-order-number').text(orderNum.substr(orderNum.length - 2) + '.')
					shownIndex++;
				} else {
					$(element).hide();
				}
			} else {
				$(element).show()
				let orderNum = '0' + shownIndex
				$(element).find('.list-order-number').text(orderNum.substr(orderNum.length - 2) + '.')
				shownIndex++;
			}
		});
	}


	let archiveTopicFilter = '';
	let archiveTopicOrder = '';
	$('#archive-order-select').on('change', function () {
		archiveTopicOrder = $(this).val();
		if (archiveTopicOrder === 'alphabetical') {
			$('#archive-topics ol.recommended').addClass('alphabetical');
		} else {
			$('#archive-topics ol.recommended').removeClass('alphabetical');
		}
		updateArchives();
	});

	$(window).load(function () {
		archiveTopicOrder = getCookie("order_archive");
		$('#archive-order-select').val(archiveTopicOrder);
		$('#archive-order-select').trigger('change');
	});

	function updateArchives() {
		let listContainer = $('#archive-topics ol.recommended');
		var $fields, sorted;

		$fields = $("#archive-topics ol.recommended li.sorted");
		sorted = [];
		let unsorted = []
		$fields.detach().each(function () {
			if (archiveTopicOrder === 'recommended') {
				if (this.getAttribute("data-" + (archiveTopicFilter || 'default') + "-order")) {
					sorted[parseInt(this.getAttribute("data-" + (archiveTopicFilter || 'default') + "-order"), 10)] = this;
				} else {
					unsorted.push(this);
				}
			} else {
				if (this.getAttribute("data-alphabetical")) {
					sorted[parseInt(this.getAttribute("data-alphabetical"), 10)] = this;
				} else {
					unsorted.push(this);
				}
			}

		});
		let shownIndex = 1;
		sorted = [...sorted, ...unsorted];
		sorted.forEach(function (element) {
			listContainer.append(element);
			if (!$(element).find('a').text()) {
				return;
			}
			if (archiveTopicFilter) {
				if (!!$(element).attr('data-category') && $(element).attr('data-category').includes(archiveTopicFilter)) {
					$(element).show()
					let orderNum = '0' + shownIndex
					$(element).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
					shownIndex++;
				} else {
					$(element).hide();
				}
			} else {
				$(element).show()
				let orderNum = '0' + shownIndex
				$(element).find('.order-number').text(orderNum.substr(orderNum.length - 2) + '.')
				shownIndex++;
			}
		});
	}

	const orderSelect = document.getElementById('archive-order-select-blog');
	const list = document.getElementById('archive-list-blog');


	const savedOrder = getCookie('listOrder');

	if (orderSelect && list) {
		if (savedOrder) {
			orderSelect.value = savedOrder;
			$(orderSelect).selectric('refresh');
			sortList(savedOrder);
		} else {
			$(orderSelect).selectric('refresh');
			sortList(orderSelect.value);
		}

		$(orderSelect).on('selectric-change', function (event) {
			const selectedOption = $(this).val();
			sortList(selectedOption);
			setCookie('listOrder', selectedOption, 365);
		});


	}

	function sortList(orderType) {
		let itemsArray = Array.from(list.children);
		if(orderType === 'newest') {
			itemsArray.sort((a, b) => new Date(b.dataset.postDate) - new Date(a.dataset.postDate));
		} else if(orderType === 'popular') {
			itemsArray.sort((a, b) => b.dataset.viewCount - a.dataset.viewCount);
		}
		itemsArray.forEach(item => list.appendChild(item));
	}

	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	// let archiveOrder = 'recommended';
	// $('#archive-order-select').on('change',function(){
	// 	topicOrder = $(this).val();
	// 	if(topicOrder === 'alphabetical'){
	// 		$('#archive-topics ol.recommended').addClass('alphabetical');
	// 	}else{
	// 		$('#archive-topics ol.recommended').removeClass('alphabetical');
	// 	}
	// 	updateArchiveTopics();
	// });
	//
	// function updateArchiveTopics() {
	// 	console.log('updateArchiveTopics')
	// 	let shownIndex = 1;
	// 	let listContainer = $('#archive-topics ol.recommended');
	// 	let dataName = '';
	// 	switch(topicOrder){
	// 		case 'recommended':
	// 			dataName = "data-suggested-order";
	// 			break;
	// 		case 'popular':
	// 			dataName = "data-view-count";
	// 			break;
	// 		case 'newest':
	// 			dataName = "data-post-date";
	// 			break;
	// 		default:
	// 			dataName = "data-alphabetical";
	// 	}
	// 	listContainer.find('li.sorted').sort(function (a, b) {
	//
	// 		if(a.getAttribute(dataName) === null){
	// 			return 1;
	// 		}
	// 		if(b.getAttribute(dataName) === null){
	// 			return -1;
	// 		}
	// 		if(dataName === 'data-suggested-order') {
	// 			return parseInt(a.getAttribute(dataName)) - parseInt(b.getAttribute(dataName));
	// 		}
	// 		if(dataName === 'data-view-count') {
	// 			return parseInt(b.getAttribute(dataName)) - parseInt(a.getAttribute(dataName));
	// 		}
	// 		if(dataName === 'data-alphabetical') {
	// 			return a.getAttribute(dataName).localeCompare(b.getAttribute(dataName));
	// 		}
	// 		let dateA = new Date(a.getAttribute(dataName));
	// 		let dateB = new Date(b.getAttribute(dataName));
	// 		console.log(dateA.getTime())
	// 		if(dateA.getTime() === dateB.getTime()){
	// 			console.log('same')
	// 			return 0;
	// 		}else if(dateB.getTime() < dateA.getTime()){
	//
	// 			return -1;
	// 		}
	// 		return 1;
	// 	}).appendTo( listContainer );
	//
	// 	listContainer.find('li.sorted').each(function(){
	// 		if(!$(this).find('a').text()){
	// 			return;
	// 		}
	//
	// 		$(this).show()
	// 		let orderNum = '0'+shownIndex
	// 		$(this).find('.order-number').text(orderNum.substr(orderNum.length-2)+'.')
	// 		shownIndex++;
	// 	})
	//
	// }

	/**
	 * general form submission
	 */

	let cropButtonClicked = false;

	$('#crop-button').on('click', function (e) {
		cropButtonClicked = true;
	});

$('form').on('submit', function (e) {
	console.log('form submitted');
    if ($(this).attr('data-ajax')) {
        e.preventDefault();
        if ($(this).attr('data-submitting') == 1) {
            return;
        }
        $(this).attr('data-submitting', 1);
        let form = $(this);
        let action = $(this).attr('data-ajax');
        let data;

		if (action === 'ac_delete_member_photo_ajax') {
			$('#profile-form .loading-spinner-delete').show();
			$('#profile-form .success-checkmark-delete').hide();
		}

        if (action === 'ac_submit_profile_settings_ajax') {
			data = new FormData(this);
			let selectedTheme = $('input[name="theme"]:checked').val();
			if (selectedTheme) {
				data.append('theme', selectedTheme);
			}

			if (cropButtonClicked) {
				form.find('.loading-spinner-photo').show();
				form.find('.success-checkmark-photo').hide();
				form.find('.loading-spinner').hide();
				cropButtonClicked = false;
			} else {
				form.find('.loading-spinner').show();
				form.find('.success-checkmark').hide();
				form.find('.loading-spinner-photo').hide();
			}

        } else {
            data = getFormData($(this));
        }

        $.ajax({
            url: accountingcoach.ajax_url + '?action=' + action,
            type: 'POST',
            data: data,
            contentType: action === 'ac_submit_profile_settings_ajax' ? false : 'application/x-www-form-urlencoded; charset=UTF-8',
            processData: action === 'ac_submit_profile_settings_ajax' ? false : true,
            success: function (res) {

				 if (action !== 'ac_delete_member_photo_ajax') {
					res = $.parseJSON(res);
                }

				if (action === 'ac_submit_profile_settings_ajax') {
					if (res.file == true) {
						form.find('.loading-spinner-photo').hide();
						// form.find('.success-checkmark-photo').show();
						form.find('.success-checkmark-photo').show().delay(2000).fadeOut();
						form.find('.loading-spinner').hide();
					} else {
						form.find('.loading-spinner').hide();
						form.find('.success-checkmark').show().delay(2000).fadeOut();
						form.find('.loading-spinner-photo').hide();
					}

					if (res['error']){
						form.find('.loading-spinner').hide();
						form.find('.loading-spinner-photo').hide();
						form.find('.success-checkmark-photo').hide();
						form.find('.success-checkmark').hide();
						cropButtonClicked = false;
						form.attr('data-submitting', 0);
					} else {
						form.find('.form-message').text(res['message']).hide();
					}
				}

				if (action === 'ac_delete_member_photo_ajax') {
					$('#profile-form .loading-spinner-delete').hide();
					$('#profile-form .success-checkmark-delete').show().delay(2000).fadeOut();

					if (res['error']) {
						$('#profile-form .loading-spinner-delete').hide();
						$('#profile-form .success-checkmark-delete').hide();
						form.attr('data-submitting', 0);
					} else {
						form.find('.form-message').text(res['message']).hide();
					}
				}

				if (res.profile_name) {
					$('#profile_name').val(res.profile_name).attr('placeholder', res.profile_name);
				}
                if (res['message']) {
                    form.find('.form-message').text(res['message']).show();
                }
                if (res['error']) {
                    form.find('.form-message').addClass('error');
					cropButtonClicked = false;
                }
                if (res['success']) {
                    form.find('.form-message').addClass('success');
                }
                if ((!res['invalid_fields'] || res['invalid_fields'].length === 0) && !res['error']) {
                    form.find('input, textarea').not('#profile_name').not('input[name="theme"]').not(':input[type=hidden],:input[type=button],:input[type=submit]').val('').removeClass('invalid-input');
                } else if (res['invalid_fields']) {
                    form.find('input, textarea').removeClass('invalid-input');
                    res['invalid_fields'].forEach(function (fieldName) {
                        $('input[name="' + formName + '[' + fieldName + ']"], textarea[name="' + formName + '[' + fieldName + ']"').addClass('invalid-input')
                    });
                }
                form.attr('data-submitting', 0);
            },
            error: function (xhr, status, error) {
                form.attr('data-submitting', 0);
				form.find('.form-message').text(xhr.responseText || 'Unable to submit, unknown error').addClass('error').show();
            }
        });
    }
});

	function getFormData($form) {
		var unindexed_array = $form.serializeArray();
		var indexed_array = {};

		$.map(unindexed_array, function (n, i) {
			indexed_array[n['name']] = n['value'];
		});

		return indexed_array;
	}

	/**
	 * progress tracking
	 */
	if ($('#the-progress-bar').length > 0) {
		updateProgressBar();
	}

	function checkMiniOutlineChildItems(itemList) {
		let complete = true;
		$(itemList).children('li').each(function () {
			if (!$(this).hasClass('complete')) {
				complete = false;
				return false;
			}
		});
		return complete;
	}

	function checkMainOutlineChildItems(childrenItems) {
		let complete = true;
		$(childrenItems).each(function () {
			if (!$(this).hasClass('completed')) {
				complete = false;
				return false;
			}
		});
		return complete;
	}

	function updateProgressBar(topicId = null, fromChildItem = false) {
		let totalParentItems = 0;
		let completedParentItems = 0;

		// Trackable outline check for both sections and parts
		if ($('dl.trackable-outline').length) {
			$('dl.trackable-outline').find('dt.trackable').each(function () {
				// Skip child items, only process parent items
				if (!$(this).attr('data-topic-parent-id')) {
					if ($(this).hasClass('certificate')) {
						return true; // Ignore certificates
					}

					totalParentItems++; // Increment total count of parent items

					let childrenItems = $(this).parent().find('dt[data-topic-parent-id="' + $(this).attr('data-topic-id') + '"]');

					// Check for completed child items if fromChildItem is true
					if (childrenItems.length && fromChildItem) {
						let completed = checkMainOutlineChildItems(childrenItems); // Function to check if all children are completed
						if (completed) {
							$(this).addClass('completed');
							completedParentItems++;
						} else {
							$(this).removeClass('completed');
						}
					} else if ($(this).hasClass('completed')) {
						completedParentItems++;
					}
				}
			});
		}

		// Mini outline check for both sections and parts
		if ($('#mini-outline-list.trackable').length) {
			$('#mini-outline-list.trackable').find('.parent-item').each(function () {
				if ($(this).hasClass('certificate')) {
					return true; // Ignore certificates
				}

				totalParentItems++;
				let childItems = $(this).find('li');
				if (childItems.length && fromChildItem) {
					let completed = checkMiniOutlineChildItems($(this).children('ul')[0]);
					if (completed) {
						$(this).addClass('complete');
						completedParentItems++;
					} else {
						$(this).removeClass('complete');
					}
				} else if ($(this).hasClass('complete')) {
					completedParentItems++;
				}
			});
		}

		// Calculate and update the progress bar
		if (totalParentItems > 0) {
			let percentComplete = Math.max(0, Math.min(Math.round((completedParentItems / totalParentItems) * 100), 100));

			// Update progress bar status
			if (percentComplete <= 0) {
				$('#the-progress-bar').addClass('progress-bar--zero');
			} else {
				$('#the-progress-bar').removeClass('progress-bar--zero');
			}

			// Set progress bar width and text
			$('#the-progress-bar > div').width(percentComplete + '%');
			$('#the-progress-bar > div > span').text(percentComplete);
			$('.topic-outline-mini__progress__number > span').text(percentComplete);

			// Update course completion for a specific topic, if topicId is provided
			if (topicId) {
				let courseCompletionHolder = $('.course-outline__topics li[data-topic-id="' + topicId + '"]').find('em');
				if (percentComplete > 0) {
					courseCompletionHolder.removeClass('empty').text(percentComplete + '%');
				} else {
					courseCompletionHolder.addClass('empty').text('');
				}
			}
		}
	}

	$('.single-topic').on('click', function () {
		$(this).toggleClass('open')
	})
	var $navigationLinks = $('.sidebar-menu > li > a');
	var $sections = $("section.help-category");
	var $sectionsReversed = $($("section.help-category").get().reverse());
	var sectionIdTonavigationLink = {};

	$sections.each(function () {
		sectionIdTonavigationLink[$(this).attr('id')] = $('.sidebar-menu > li > a[href="#' + $(this).attr('id') + '"]');
	});

	$(window).on('scroll', function () {

		var scrollPosition = $(window).scrollTop();

		$sectionsReversed.each(function () {
			var currentSection = $(this);
			var sectionTop = currentSection.offset().top - 300;


			if (scrollPosition >= sectionTop) {
				var id = currentSection.attr('id');
				var $navigationLink = sectionIdTonavigationLink[id];
				if (!$navigationLink.hasClass('active')) {
					$navigationLinks.removeClass('active');
					$navigationLink.addClass('active');
				}
				return false;
			}
		});
	});
	$('.help-category .topic-title').on('click', function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		$(this).closest('dl').toggleClass('open');
	})

	//
	function updateVideoProgressBar() {
		let totalParts = 0;
		let completedParts = 0;
		$('dl.trackable-video-outline').find('dt.trackable').each(function () {
			totalParts++;
			if ($(this).hasClass('completed')) {
				completedParts++;
			}

		})
		if (totalParts <= 0) {
			return;
		}
		let percentComplete = Math.max(0, Math.min(Math.round((completedParts / totalParts) * 100), 100));
		$('#the-progress-bar>div').width(percentComplete + '%');
		$('#the-progress-bar>div>span').text(percentComplete);

	}

	// $('#mini-outline-list.trackable').find('.parent-item > span').on('click', function(event) {
	// 	let parentItem = $(this).closest('.parent-item');
	// 	let childItems = parentItem.find('li');

	// 	if (!$(this).hasClass('complete')) {
	// 		$(this).addClass('complete');
	// 	}

	// 	if (childItems.length) {
	// 		if ($(this).hasClass('complete')) {
	// 			childItems.addClass('complete');
	// 			childItems.find('span').addClass('complete');
	// 		}
	// 	}

	// });

	$('dt.parent-item span.check').on('click', function() {
		var $dtParentItem = $(this).closest('dt.parent-item');

		// if (!$dtParentItem.hasClass('complete')) {
		// 	$dtParentItem.addClass('complete');
		// }

		var parentTopicId = $dtParentItem.data('topic-id');

		var $nextDl = $dtParentItem.nextAll('dl').first();

		$nextDl.find('dt').each(function() {
			if ($(this).data('topic-parent-id') === parentTopicId) {
				$(this).addClass('completed');
			}
		});
	});




	updateVideoProgressBar();
	let trackingUpdateIndex = 0;
	$('#topic-outline-holder, .toc-box').on('click', '.check', function (e) {
		e.preventDefault();

		// Check if the clicked element belongs to a trackable outline
		if (!$(this).closest('.trackable-outline').length) {
			window.location.href = '/pro?feature=progress-tracking';
			return false;
		}

		// Get the parent <dt> and extract necessary data
		let parentDt = $(this).closest('dt');
		let topicId = parentDt.attr('data-topic-id');
		// let mainTopicId = parentDt.attr('data-topic-parent-id');
		let mainTopicId = parentDt.attr('data-main-topic-id');
		let isCompleted = parentDt.hasClass('completed');

		// Prepare the data for the AJAX request
		let postData = {
			parent_topic: mainTopicId,
			topic_id: topicId,
			current_post: $('#mini-outline-list').attr('data-current-post'),
			item_status: isCompleted ? 'incomplete' : 'complete',
			page: 'outline'
		};


		// Toggle the 'completed' class for the clicked item (TOC)
		parentDt.toggleClass('completed');

		// Update the progress bar and other related UI elements
		updateCompletionStatus(topicId, !isCompleted);
		updateProgressBar(parentDt.attr('data-main-topic-id'), mainTopicId);

		// Send an AJAX request to update the backend with the new completion status
		trackingUpdateIndex = Math.random();
		let curTrackingIndex = trackingUpdateIndex;
		clearAchievementPopup();
		$.post(accountingcoach.ajax_url + '?action=ac_record_member_item', postData)
			.then(function (res) {
				if (curTrackingIndex === trackingUpdateIndex) {
					getUpdatedAchievementPopup();
					updateSidebarTopics();
					trackingUpdateIndex = -1;
				}
			})
			.catch(function (e) {
				console.log(e);
			});
	});

	// Function to update the completion status in mini outline, buttons, and TOC
	function updateCompletionStatus(topicId, isComplete) {

		// Update button
		const button = $('.mark-complete[data-item-id="' + topicId + '"] a');
		if (button.length) {
			button.toggleClass('button--progress--done', isComplete);
			// Call updateText to change the button text based on the status
			updateText(topicId);
		}

		// Update mini outline item
		const miniOutlineItem = $('.topic-outline-mini-item[data-topic-id="' + topicId + '"]');
		if (miniOutlineItem.length) {
			miniOutlineItem.toggleClass('complete', isComplete);
			miniOutlineItem.find('span').toggleClass('complete', isComplete);
		}
		const parentItemId = miniOutlineItem.data('topic-parent-id');
        if (parentItemId) {
            updateParentCompletionStatus(parentItemId);
        }

		// Update TOC item (if it wasn't updated in the click event)
		const tocItem = $('.toc-link[data-topic-id="' + topicId + '"]');
		if (tocItem.length) {
			tocItem.toggleClass('completed', isComplete);
			tocItem.find('span').toggleClass('completed', isComplete);
		}
	}

	function updateParentCompletionStatus(parentItemId) {
		const parentItem = $('.topic-outline-mini-item[data-topic-id="' + parentItemId + '"]');
		if (parentItem.length) {
			const childItems = parentItem.find('> ul > .topic-outline-mini-item');
			const allChildrenComplete = childItems.length > 0 && childItems.filter('.complete').length === childItems.length;

			let mainTopicId = parentItem.attr('data-main-topic-id');
			let postData = {
				parent_topic: mainTopicId,
				topic_id: parentItemId,
				current_post: $('#mini-outline-list').attr('data-current-post'),
				item_status: allChildrenComplete ? 'complete' : 'incomplete',
				page: 'outline'
			};

			// Update the completion status via AJAX
			trackingUpdateIndex = Math.random();
			let curTrackingIndex = trackingUpdateIndex;

			// Clear existing achievement popup
			clearAchievementPopup();

			// Send AJAX request
			$.post(accountingcoach.ajax_url + '?action=ac_record_member_item', postData)
				.then(function (res) {
					if (curTrackingIndex === trackingUpdateIndex) {
						getUpdatedAchievementPopup(); // Update achievement popup
						updateSidebarTopics(); // Update the sidebar
						trackingUpdateIndex = -1;
					}
				})
				.catch(function (e) {
					console.log(e);
				});

			if (allChildrenComplete) {
				parentItem.addClass('complete');
				parentItem.find('span').addClass('complete');
			} else {
				parentItem.removeClass('complete');
				parentItem.find('span').removeClass('complete');
			}
		}
	}

	function updateCompletionStatus2(topicId, isComplete) {

		// Update button
		const button = $('.mark-complete[data-item-id="' + topicId + '"] a');
		if (button.length) {
			button.toggleClass('button--progress--done', isComplete);
			// Call updateText to change the button text based on the status
			updateText(topicId);
		}

		// Update TOC item (if it wasn't updated in the click event)
		const tocItem = $('.toc-link[data-topic-id="' + topicId + '"]');
		if (tocItem.length) {
			tocItem.toggleClass('completed', isComplete);
			tocItem.find('span').toggleClass('completed', isComplete);
		}
	}

	$('.mark-complete').on('click', 'a', function (e) {
		e.preventDefault();
		markComplete2($(this), e);
	})

	$('#mini-outline-list').on('click', '.topic-outline-mini-item span', function (e) {
		e.preventDefault();
		if ($(this).hasClass('not-trackable')) {
			window.location.href = '/pro?feature=progress-tracking'
			return false;
		}
		let fromChild = $(this).parent().attr('data-main-topic-id');
		let postData = {
			parent_topic: $(this).parent().attr('data-main-topic-id'),
			topic_id: $(this).parent().attr('data-topic-id'),
			current_post: $('#mini-outline-list').attr('data-current-post'),
			item_status: $(this).parent().hasClass('complete') ? 'incomplete' : 'complete',
			page: 'outline',
			type: 'mini'
		};
		$(this).toggleClass('complete').parent().toggleClass('complete');
		updateProgressBar($(this).parent().attr('data-main-topic-id'), false);
		const itemId = $(this).parent().attr('data-topic-id');
		let isCompleted = $(this).parent().hasClass('complete');
		// console.log(itemId, isCompleted);
		updateCompletionStatus2(itemId, isCompleted);
		trackingUpdateIndex = Math.random();
		let curTrackingIndex = trackingUpdateIndex;
		clearAchievementPopup();
		$.post(accountingcoach.ajax_url + '?action=ac_record_member_item', postData).then(function (res) {
			if (curTrackingIndex === trackingUpdateIndex) {
				getUpdatedAchievementPopup();
				updateSidebarTopics();
			}
		}).catch(function (e) {
			console.log(e);
		})
	})

	function markComplete2(el) {
		// Prevent multiple simultaneous clicks
		if (el.data('submitting')) {
			return;
		}

	// Ensure that the clicked element is trackable
	if (!el.parent().hasClass('trackable')) {
		window.location.href = '/pro?feature=progress-tracking';
		return false;
	}

	// Get parent topic and split if necessary
	let parentTopic = el.parent().attr('data-main-topic-id');
	if (parentTopic && parentTopic.includes(',')) {
		parentTopic = parentTopic.split(',');
	}

	// Prepare post data for AJAX
	let postData = {
		parent_topic: parentTopic,
		topic_id: el.parent().attr('data-item-id'),
		current_post: $('#mini-outline-list').attr('data-current-post'),
		item_status: el.hasClass('button--progress--done') ? 'incomplete' : 'complete',
		page: 'outline'
	};

	let isCompleted = el.hasClass('button--progress--done');

	el.toggleClass('button--progress--done', !isCompleted);
	updateText(el.parent().attr('data-item-id'));
	const miniOutlineItem = $('.topic-outline-mini-item[data-topic-id="' + el.parent().attr('data-item-id') + '"]');
	if (miniOutlineItem.length) {
		miniOutlineItem.toggleClass('complete', !isCompleted);
		miniOutlineItem.find('span').toggleClass('complete', !isCompleted);
	}
	const parentItemId = miniOutlineItem.data('topic-parent-id');
	if (parentItemId) {
		updateParentCompletionStatus(parentItemId);
	}

	// Update TOC item (if it wasn't updated in the click event)
	const tocItem = $('.toc-link[data-topic-id="' + el.parent().attr('data-item-id') + '"]');
	if (tocItem.length) {
		tocItem.toggleClass('completed', !isCompleted);
		tocItem.find('span').toggleClass('completed', !isCompleted);
	}

	if (tocItem.length) {
		tocItem.toggleClass('completed', !isCompleted);
		tocItem.find('span').toggleClass('completed', !isCompleted);
	}

	updateProgressBar(parentTopic, true);

	trackingUpdateIndex = Math.random();
	let curTrackingIndex = trackingUpdateIndex;
	clearAchievementPopup();
	$.post(accountingcoach.ajax_url + '?action=ac_record_member_item', postData).then(function (res) {
		if (curTrackingIndex === trackingUpdateIndex) {
			getUpdatedAchievementPopup();
			updateSidebarTopics();
		}
	}).catch(function (e) {
		console.log(e);
	}).always(function () {
		// Restore original text and remove submitting flag
		el.data('submitting', false);
	});

	var $dtParentItem = $('.topic-outline-mini-item[data-topic-id="' + el.parent().attr('data-item-id') + '"]').closest('dt.parent-item');

	if (!$dtParentItem.hasClass('completed')) {
		$dtParentItem.addClass('completed');
	}

	var parentTopicId = $dtParentItem.data('topic-id');

	var $nextDl = $dtParentItem.nextAll('dl').first();

	$nextDl.find('dt').each(function() {
		if ($(this).data('topic-parent-id') === parentTopicId) {
			$(this).addClass('completed');
		}
	});
}

	$('#mark-all-qa').on('click', 'a.incomplete', function (e) {
		e.preventDefault();
		let postData = {
			topic_id: $(this).parent().attr('data-topic-id'),
			item_status: 'complete',
			page: 'outline',
			type: 'qa'
		};
		$(this).parent().addClass('complete');
		$(this).addClass('complete');
		$(this).removeClass('incomplete');
		trackingUpdateIndex = Math.random();
		let curTrackingIndex = trackingUpdateIndex;
		clearAchievementPopup();
		updateProgressBar($(this).parent().attr('data-topic-id'))
		$.post(accountingcoach.ajax_url + '?action=ac_record_member_topic_qas', postData).then(function (res) {
			if (curTrackingIndex === trackingUpdateIndex) {
				getUpdatedAchievementPopup();
				updateSidebarTopics();
			}
		}).catch(function (e) {
			console.log(e);
		})
	})

	$('#video-outline-holder').on('click', '.check', function (e) {

		let parentDt = $(this).closest('dt');
		let postData = {
			video_topic_id: parentDt.attr('data-parent-id'),
			video_part_id: parentDt.attr('data-part-id'),
			current_part_num: $('#video-outline-holder').attr('data-current-part-number'),
			item_status: parentDt.hasClass('completed') ? 'incomplete' : 'complete',
			page: 'outline'
		};
		parentDt.toggleClass('completed');
		updateNextVideoIndicator();
		trackingUpdateIndex = Math.random();
		let curTrackingIndex = trackingUpdateIndex;
		clearAchievementPopup();
		updateVideoProgressBar(parentDt.attr('data-main-topic-id'));
		$.post(accountingcoach.ajax_url + '?action=ac_record_member_video_part', postData).then(function (res) {
			if (curTrackingIndex === trackingUpdateIndex) {
				updateVideoProgressBar(parentDt.attr('data-main-topic-id'));
				getUpdatedAchievementPopup();
			}
		}).catch(function (e) {
			console.log(e);
		})
	});

	function updateNextVideoIndicator() {
		// Remove the existing indicator
		$('.next-video-indicator').remove();

		// Find the part with the "watching-indicator" label
		let watchingPart = $('.watching-indicator').closest('.parent-item');

		// Find the first uncompleted part in the list
		let uncompletedPart = $('.parent-item:not(.completed)').first();

		// If the uncompleted part found has the `watching-indicator` active, try finding the next uncompleted part
		if (uncompletedPart.find('.watching-indicator').length) {
			let nextUncompletedPart = uncompletedPart.nextAll('.parent-item:not(.completed)').first();
			if (nextUncompletedPart.length) {
				uncompletedPart = nextUncompletedPart;
			} else {
				// If there is no next uncompleted part, try finding the previous uncompleted part
				let prevUncompletedPart = uncompletedPart.prevAll('.parent-item:not(.completed)').first();
				if (prevUncompletedPart.length) {
					uncompletedPart = prevUncompletedPart;
				} else {
					// If there is no previous uncompleted part, set uncompletedPart to an empty jQuery object
					uncompletedPart = $();
				}
			}
		}

		// If there is an uncompleted part
		if (uncompletedPart.length) {
			// Add the new indicator to the uncompleted part
			let newIndicator = $('<label class="next-video-indicator">Next Video</label>');
			uncompletedPart.find('.video-part-link').append(newIndicator);
		}
	}


	updateNextVideoIndicator()
	/**
	 * new achievement popup function
	 */
	$('body').on('click', '.badge-overlay, .close-button', function () {
		clearAchievementPopup();
	});

	if ($('#new-achievement-popup').length) {
		moveShowAchievementPopup();
	}

	function clearAchievementPopup() {
		$('input[name="new-point-total"]').remove();
		$('.badge-overlay').remove();
	}

	function getUpdatedAchievementPopup() {
		if (!$('.badge-overlay').length) {
			clearAchievementPopup();
			$.get(accountingcoach.ajax_url + '?action=ac_get_achievement_popup').then(function (res) {
				$('body').append(res);
				moveShowAchievementPopup();
				$('body').trigger('custom:achievement-popup-updated', res);
			}).catch(function (e) {
				console.log(e);
			})
		}
	}

	let isAnimating = false;

	function moveShowAchievementPopup() {
		let popup = $('.badge-overlay');
		let newPointTotal = $('input[name="new-point-total"]').val();
		$('.point-total__number').text(newPointTotal);
		$('.progress-bar-container .point-total').text(newPointTotal);

		updateBadgePointTotal();

		if (popup.length && !isAnimating) {
			isAnimating = true;
			popup.detach().appendTo('body').show();
			let confetti = new Confetti("confetti-anchor");
			confetti.setCount(75);
			confetti.setSize(2.5);
			confetti.setPower(35);
			confetti.setFade(true);
			confetti.destroyTarget(false);
			document.getElementById("confetti-anchor").click();
			setTimeout(() => {
				isAnimating = false;
			}, 1500);
		}
	}

	function markBadgesCompleteFromHTML(htmlStr) {
		for (const badgeMatch of htmlStr.matchAll(/big-badge--completed-(.+)\"/g)) {
			if (badgeMatch.length == 2) {
				$('.badge--completed-' + badgeMatch[1]).addClass('badge--completed');
			}
		}
	}
	$('body').on('custom:achievement-popup-updated', function(e, data) {
		markBadgesCompleteFromHTML(data);
	});

	/**
	 * accordian
	 */
	$('.accordion').on('click', 'dt', function () {
		$(this).nextUntil('dt').slideToggle(300)
	})


	/**
	 * certificate exams
	 */

	let certExamTimer = $('#exam-timer');
	let certExamTimeLeft = 0;
	let submittingCertificate = false;

	let overrideCertificateSubmit = false;
	$('.exam-overlay .submit-exam').on('click', function (e) {
		e.preventDefault();
		overrideCertificateSubmit = true;
		window.removeEventListener("beforeunload", alertWhenLeavingExam);
		$('#certificate-exam-form').submit()
	});
	$('#continue-exam').on('click', function (e) {
		e.preventDefault();
		overrideCertificateSubmit = false;
		$('.exam-overlay').hide();
	})
	$('#unmarked-overlay').on('click', '.overlay-close', function (e) {
		e.preventDefault();
		overrideCertificateSubmit = false;
		$('.exam-overlay').hide();
	})
	if (certExamTimer.length) {
		updateCertExamTimer();
	}
	$('#certificate-exam-form').on('submit', function (e) {
		if (overrideCertificateSubmit) {
			return true;
		}
		let numberOfUnanswered = 0;
		$('#certificate-exam-form select').each(function () {
			if ($(this).val() == '' || $(this).val() === 'Select...' || $(this).val() === 'empty') {
				numberOfUnanswered++;
			}
		});
		if (numberOfUnanswered > 0) {
			$('#num-questions-left').text(numberOfUnanswered);
			$('#unmarked-overlay').css('display', 'flex');
			return false;

		}
		submittingCertificate = true;
	});

	let start = new Date();
	if (typeof examMinutes !== 'undefined' && examMinutes) {
		start.setTime(start.getTime() + (examMinutes * 60 * 1000));
	}

	function updateCertExamTimer() {
		let current = new Date();
		let count = +start - +current;
		let s = Math.floor((count / 1000)) % 60;
		// let m = Math.floor((count / 60000)) % 60;
		let m = Math.floor(count / 60000);

		if (typeof start === 'undefined' || isNaN(start.getTime())) {
			setTimeout(updateCertExamTimer, 1000);
			return;
		}

		$('#exam-timer-display').text(String(m).padStart(2, '0') + ":" + String(s).padStart(2, '0'));

		if (count <= 0) {
			$('#time-overlay').css('display', 'flex');
			return false;
		} else {
			setTimeout(updateCertExamTimer, 1000);
		}
	}

	if ($('#certificate-exam-form').length) {
		window.addEventListener("beforeunload", alertWhenLeavingExam);
	}

	function alertWhenLeavingExam(e) {
		if (submittingCertificate) {
			return undefined;
		}
		let confirmationMessage = 'If you leave this page your Exam attempt will be used but not graded.';

		return confirmationMessage;
	}

	/**
	 * webinarDiscount
	 */


	let startDiscount;

	window.addEventListener('unlockedEvent', function(e) {
		if (!startDiscount) {
			startDiscount = new Date();
			let discountMinutes = 30;
			if (typeof discountMinutes !== 'undefined' && discountMinutes) {
				startDiscount.setTime(startDiscount.getTime() + (discountMinutes * 60 * 1000));
			}
		}
		updateWebinarDiscountTimer();
	}, false);
	function updateWebinarDiscountTimer() {
		let current = new Date();
		let count = +startDiscount - +current;
		let s = Math.floor((count / 1000)) % 60;
		let m = Math.floor((count / 60000)) % 60;

		$('#webinarDiscountDisplay').text(String(m).padStart(2, '0') + ":" + String(s).padStart(2, '0'));

		if (count <= 0) {
			$('.webinar-unlock').removeClass('lockon').addClass('exp');
			// $('.webinar-unlock .expired').css('display', 'flex');
			// $('.webinar-unlock .unlocked').css('display', 'none');
			// Reset background color and padding of .webinar-unlock__inside
			// $('.webinar-unlock').css('backgroundColor', '');
			// $('.webinar-unlock__inside').css('padding', '');
			return false;
		} else {
			setTimeout(updateWebinarDiscountTimer, 1000);
		}
	}

	/**
	 * word scrambles
	 */
	$('#word-scramble-question-list').on('click', 'a', function (e) {
		e.preventDefault();
		if ($(this).text() === 'Unscramble') {
			$(this).text('Scramble').addClass('light');
		} else {
			$(this).text('Unscramble').removeClass('light');
		}
		$(this).parent().parent().find('.scrambled').toggle();
		$(this).parent().parent().find('.unscrambled').toggle();
		if ($(this).parent().parent().find('.unscrambled:visible').length <= 0) {
			markCurrentWordScrambleComplete();
		}
	});
	$('#scramble-mark-complete').on('click', 'a', function (e) {
		e.preventDefault();
		markCurrentWordScrambleComplete();
	})
	$('.not-trackable').on('click', function (e) {
		if (!$(e.target).hasClass('not-trackable')) {
			return true;
		}
		if ($(this).closest('#topic-outline').length) {
			return true;
		}
		e.preventDefault();
		window.location.href = '/pro?feature=progress-tracking'
		return false;
	})

	function markCurrentWordScrambleComplete() {
		if (!$('#scramble-mark-complete').hasClass('trackable')) {
			//window.location.href = '/pro?feature=progress-tracking'
			return false;
		}
		let postData = {
			topic_id: $('#scramble-word-scramble-question-list').attr('data-topic-id'),
			item_status: 'complete'
		};
		$('#scramble-mark-complete-trigger').removeClass('incomplete').addClass('complete');
		$('#scramble-mark-complete').removeClass('incomplete').addClass('complete');
		submittingItemStatus = true;
		clearAchievementPopup();
		$.post(accountingcoach.ajax_url + '?action=ac_record_member_topic', postData).then(function (res) {
			$('body').append(res)
			updateProgressBar($('#word-scramble-question-list').attr('data-topic-id'))
			moveShowAchievementPopup();
			submittingItemStatus = false;
			updateSidebarTopics();
		}).catch(function (e) {
			console.log(e);
			$('#scramble-mark-complete-trigger').removeClass('complete').addClass('incomplete');
			$('#scramble-mark-complete').removeClass('complete').addClass('incomplete')
			submittingItemStatus = false
		})
	}

	$('.wistia-play-button').on('click', function (e) {
		e.preventDefault();
		let videoId = $(this).attr('data-video-id');
		if (!videoId) {
			return;
		}
		window._wq = window._wq || [];
		_wq.push({
			id: videoId, onReady: function (video) {
				video.play();
			}
		});

	});
	$('.feedback-form-trigger').on('click', function (e) {
		e.stopPropagation();
		if (e.preventDefault()) {
			e.preventDefault()
		}
		$(this).parent().find('textarea').attr('placeholder', 'Comments...');
		$(this).parent().find('textarea').val('')
		$(this).parent().find('.feedback-form-holder').removeClass('submitted');
		$(this).parent().find('.feedback-form-holder').find('.form-message').text('').removeClass('error').hide();
		$(this).parent().find('.feedback-form-holder').toggle();
	});
	$('.feedback-form-holder').on('click', 'button', function () {
		let form = $(this).parent();
		if (form.attr('data-submitting') == 1) {
			return;
		}
		form.attr('data-submitting', 1);
		form.find('.form-message').text('').removeClass('error').hide();
		let feedback = $(this).parent().find('textarea[name="feedback"]').val();
		let explanationName = $(this).closest('.btns_holder').prevAll('article').first().attr('data-explanation-name');
		if (!explanationName) {
			explanationName = "assessment-suggest-test";
		}
		let honeypot = form.find('input[name="hp-url"]').val(); // Honeypot field
		if (honeypot !== "") {
			console.log('Spam detected via honeypot.');
			form.attr('data-submitting', 0);
			return;
		}
		let postData = {
			explanation_part: explanationName,
			feedback: feedback
		}
		$.post(accountingcoach.ajax_url + '?action=ac_ajax_submit_explanation_feedback', {contact: postData})
        .then(function (res) {
            res = $.parseJSON(res);
            if (res['message']) {
                form.find('.form-message').text(res['message']).show();
            }
            form.attr('data-submitting', 0);
            form.addClass('submitted');
        }).catch(e => {
            console.log(e);
            form.find('.form-message').text(e.message || 'Unable to submit, Unknown error').addClass('error').show();
            form.attr('data-submitting', 0);
        });
	});


    const recoveryForm = document.getElementById('recovery-form');
    if (recoveryForm) {
        recoveryForm.addEventListener('submit', function(event) {
            event.preventDefault();
            grecaptcha.execute('6LfvBgAVAAAAADJeWVezAPuuoacbhw4wVIYHfPZh', {action: 'submit'}).then(function (token) {
                document.getElementById('token').value = token;
                recoveryForm.submit();
            }).catch(function (error) {
                console.error('reCAPTCHA ERROR:', error);
            });
        });
    }

	$("body").click(function () {
		$(".feedback-form-holder").slideUp();
	});
	$('.feedback-form-holder').on('click', '.close-link', function () {
		$(".feedback-form-holder").slideUp();
	})
	$(".feedback-form-holder").click(function (e) {
		e.stopPropagation();
	});

	$('#search-result-type').on('change', 'select', function () {
		$(this).closest('form').submit();
	});
	let formSubmitted = false;

	$('#quick-test-form').on('submit', function (e) {
		if (!formSubmitted) {
			e.preventDefault();
			formSubmitted = true;

			// Check if the .mark-complete-trigger div exists
			if ($('.mark-complete').length) {
				// console.log($('.mark-complete-trigger').text());
				// console.log('triggered');

				// if (!$('.mark-complete-trigger').text().includes('Done!')) {
				// 	// Trigger the 'mark complete' functionality
				// 	markComplete($('.mark-complete-trigger'), null, function () {
				// 		$('#quick-test-form').submit();
				// 	});
				$('.mark-complete a').trigger('click');
				$('#quick-test-form').trigger('submit');
			} else {
				// If .mark-complete-trigger div does not exist, directly submit the form
				$('#quick-test-form').trigger('submit');
			}
		}
	});

	$('.download-content button[value="alphabetical"]').each(function() {
        $(this).click();
    });


	// $('.mark-complete-trigger').on('click', function (e) {
	// 	e.preventDefault();
	// 	const itemId = $(this).data('item-id');
	// 	updateText(itemId);
	// });

	function updateText(itemId) {
		const markCompleteElement = $('.mark-complete[data-item-id="' + itemId + '"] a');
		const dataType = markCompleteElement.data('type');
		const markCompleteTextElement = markCompleteElement.find('.mark-complete-text');
		const currentText = markCompleteTextElement.text();
		let newText;

		switch (dataType) {
			case 'all-qna':
				newText = currentText === 'Mark all Questions as Read' ? 'Questions Read' : 'Mark all Questions as Read';
				break;
			case 'qna':
				newText = currentText === 'Mark the Question as Read' ? 'Question Read' : 'Mark the Question as Read';
				break;
			case 'practice-quiz':
				newText = currentText === 'Mark the Quiz as Complete' ? 'Done! View Your Progress Below' : 'Mark the Quiz as Complete';
				break;
			case 'guide':
				newText = currentText === 'Mark the Guide as Complete' ? 'Done! View Your Progress Below' : 'Mark the Guide as Complete';
				break;
			case 'flashcard':
				newText = currentText === 'Mark the Flashcards as Complete' ? 'Done! View Your Progress Below' : 'Mark the Flashcards as Complete';
				break;
			case 'word-scramble':
				newText = currentText === 'Mark the Word Scramble as Complete' ? 'Done! View Your Progress Below' : 'Mark the Word Scramble as Complete';
				break;
			case 'crossword':
				newText = currentText === 'Mark the Crossword Puzzle as Complete' ? 'Done! View Your Progress Below' : 'Mark the Crossword Puzzle as Complete';
				break;
			case 'explanation':
				const explanationNumber = markCompleteElement.data('explanation-page');
				const totalExplanations = markCompleteElement.data('explanation-parts');
				if (explanationNumber == totalExplanations) {
					newText = currentText === `Mark Section as Complete`
						? 'Done! View Your Progress Below' : `Mark Section as Complete`;
				} else {
					newText = currentText === `Mark Section as Complete`
						? `Done! Continue Reading` : `Mark Section as Complete`;
				}
				break;
			case 'cheat-sheet':
				newText = currentText === 'Mark the Cheat Sheet as Complete' ? 'Done! View Your Progress Below' : 'Mark the Cheat Sheet as Complete';
				break;
			case 'quick-test':
				newText = currentText === 'Mark the Quick Test as Complete' ? 'Done! View Your Progress Below' : 'Mark the Quick Test as Complete';
				break;
			case 'visual-tutorial':
				newText = currentText === 'Mark the Tutorial as Complete' ? 'Done! View Your Progress Below' : 'Mark the Tutorial as Complete';
				break;
			case 'business-forms':
				newText = currentText === 'Mark the Business Forms as Complete' ? 'Done! View Your Progress Below' : 'Mark the Business Forms as Complete';
				break;
			default:
				newText = currentText;
		}

		markCompleteTextElement.text(newText);
	}

	//Fire change event for alphabetical sorting
	//const archiveOrderSelect = document.getElementById('archive-order-select');
	//archiveOrderSelect.dispatchEvent(new Event('change'));
	const archiveOrderSelect = document.getElementById('archive-order-select');
	if (archiveOrderSelect) {
		archiveOrderSelect.dispatchEvent(new Event('change'));
	}


	const allTopicOrderSelect = document.getElementById('all-topic-order-select');
	if (allTopicOrderSelect) {
		allTopicOrderSelect.dispatchEvent(new Event('change'));
	}


	function assignBadge(score, element) {
		const bronzeMin = parseInt(element.getAttribute('data-bronze-min'), 10);
		const bronzeMax = parseInt(element.getAttribute('data-bronze-max'), 10);
		const silverMin = parseInt(element.getAttribute('data-silver-min'), 10);
		const silverMax = parseInt(element.getAttribute('data-silver-max'), 10);
		const goldMin = parseInt(element.getAttribute('data-gold-min'), 10);
		const goldMax = parseInt(element.getAttribute('data-gold-max'), 10);

		if (score < bronzeMin) {
			return 'default';
		}

		let rank = 'default';
		let closestRank = null;
		let smallestDifference = Number.MAX_SAFE_INTEGER;

		const thresholds = [
			{rank: 'bronze', min: bronzeMin, max: bronzeMax},
			{rank: 'silver', min: silverMin, max: silverMax},
			{rank: 'gold', min: goldMin, max: goldMax},
		];

		for (const threshold of thresholds) {
			if (score >= threshold.min && score <= threshold.max) {
				rank = threshold.rank;
				break;
			} else {
				const minDifference = Math.abs(score - threshold.min);
				const maxDifference = Math.abs(score - threshold.max);
				if (minDifference < smallestDifference) {
					smallestDifference = minDifference;
					closestRank = threshold.rank;
				}
				if (maxDifference < smallestDifference) {
					smallestDifference = maxDifference;
					closestRank = threshold.rank;
				}
			}
		}

		if (score > thresholds[thresholds.length - 1].max) {
			rank = thresholds[thresholds.length - 1].rank;
		}

		if (rank === 'default' && closestRank) {
			rank = closestRank;
		}

		return rank;
	}

	function getTooltip(rank) {
		switch (rank) {
			case 'bronze':
				return 'Bronze medal <br> (Top 10% of users)';
			case 'silver':
				return 'Silver medal <br> (Top 5% of users)';
			case 'gold':
				return 'Gold medal <br> (Top 2% of users)';
			default:
				return 'Earn medals (Gold, Silver, Bronze) for being a top ranked user';
		}
	}

	function updateBadgeClass(element, score) {
		const newRank = assignBadge(score, element);
		element.className = `img-container ${newRank}`;
		element.setAttribute('data-badge-title', getTooltip(newRank));
	}

	function updateBadgePointTotal() {
		const pointTotalElement = document.querySelector('.progress-bar-container .point-total');
		let newPointTotal = parseInt(pointTotalElement.textContent.replace(',', ''), 10);

		let badgeElement = pointTotalElement.closest('.progress-bar-container--outer').querySelector('.img-container');
		updateBadgeClass(badgeElement, newPointTotal);
	}

	function getScoreFromSpan(spanElement) {
		const currentText = $(spanElement).text().trim();
		const [currentComplete] = currentText.split('/').map(Number);
		return currentComplete;
	}


	function updateCompleteClass(emElement) {
		const parentAnchor = $(emElement).closest("a.special-type");
		const percentageText = $(emElement).text();
		const previousPercentage = $(emElement).data("previousPercentage");

		if (percentageText !== previousPercentage) {
			$(emElement).data("previousPercentage", percentageText);


			if (percentageText === "100%") {
				parentAnchor.addClass("complete");

				const parentLi = $(emElement).closest("li");
				const categories = parentLi.data("category").split(',');

				categories.forEach(category => {
					const spanElement = $(`span.${category.trim()}`);
					if (spanElement.length > 0) {
						const currentText = spanElement.text();
						const [currentComplete, total] = currentText.split('/').map(Number);

						const newComplete = currentComplete + 1;
						spanElement.text(`${newComplete}/${total}`);

						// Update background color

						// Update progress bar width
						const progressBar = spanElement.closest('div');
						const newWidth = (newComplete / total) * 100;
						progressBar.css('width', `${newWidth}%`);

						if (newComplete === 0) {
							progressBar.css("background-color", "gray");
						} else {
							progressBar.css("background-color", "");
						}

						const badgeElement = spanElement.closest('.progress-bar-container--outer').find('.img-container')[0];
						const newScore = getScoreFromSpan(spanElement);
						updateBadgeClass(badgeElement, newScore);

					}
				});

			} else {
				parentAnchor.removeClass("complete");
				if (previousPercentage === "100%") {
					const parentLi = $(emElement).closest("li");
					const categories = parentLi.data("category").split(',');

					categories.forEach(category => {
						const spanElement = $(`span.${category.trim()}`);
						if (spanElement.length > 0) {
							const currentText = spanElement.text();
							const [currentComplete, total] = currentText.split('/').map(Number);

							const newComplete = currentComplete - 1;
							if (newComplete >= 0) {
								spanElement.text(`${newComplete}/${total}`);

								// Update background color

								// Update progress bar width
								const progressBar = spanElement.closest('div');
								const newWidth = (newComplete / total) * 100;
								progressBar.css('width', `${newWidth}%`);

								if (newComplete === 0) {
									progressBar.css("background-color", "gray");
								} else {
									progressBar.css("background-color", "");
								}

								const badgeElement = spanElement.closest('.progress-bar-container--outer').find('.img-container')[0];
								const newScore = getScoreFromSpan(spanElement);
								updateBadgeClass(badgeElement, newScore);

							}
						}
					});
				}
			}

			if (percentageText === "0%") {
				$(emElement).css("display", "none");
			} else {
				$(emElement).css("display", "");
			}
		}
	}


// Only look for changes in text node

const observer = new MutationObserver(function (mutations) {
	mutations.forEach(function (mutation) {
		if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
			mutation.addedNodes.forEach(node => {
				if (node.nodeType === Node.TEXT_NODE) {
					const emElement = mutation.target;
					updateCompleteClass(emElement);
				}
			});
		}
	});
});

const observerConfig = {childList: true};

$("em.completion-percent").each(function () {
	$(this).data("previousPercentage", $(this).text());
	observer.observe(this, observerConfig);
	let percentageText = $(this).text();
	if (percentageText === "0%") {
		$(this).css("display", "none");
	} else {
		$(this).css("display", "");
	}
});

function markComplete(el, e = null, postMarkCallBack = null) {
	if(e) {
		e.preventDefault();
	}
	if (!el.hasClass('trackable')) {
		window.location.href = '/pro?feature=progress-tracking'
		return false;
	}
	let fromChild = false;

	let parentTopic = el.parent().attr('data-main-topic-id');
	if(parentTopic && parentTopic.includes(',')) {
		parentTopic = parentTopic.split(',');
	}

	let postData = {
		parent_topic: parentTopic,
		topic_id: el.parent().attr('data-item-id'),
		current_post: $('#mini-outline-list').attr('data-current-post'),
		item_status: el.hasClass('button--progress--done') ? 'incomplete' : 'complete',
		type: 'mini'
	};
	let miniItem = $('.topic-outline-mini-item[data-item-id="' + el.parent().attr('data-item-id') + '"]');
	if (miniItem.length) {
		miniItem.toggleClass('complete').find('span').toggleClass('complete')
		if (miniItem.attr('data-topic-parent-id')) {
			fromChild = true;
		}
	}
	el.toggleClass('button--progress--done');
	trackingUpdateIndex = Math.random();
	let curTrackingIndex = trackingUpdateIndex;
	clearAchievementPopup();
	updateProgressBar(el.parent().attr('data-main-topic-id'), fromChild)
	$.post(accountingcoach.ajax_url + '?action=ac_record_member_item', postData).then(function (res) {
		if(postMarkCallBack) {
			postMarkCallBack();
		} else if (curTrackingIndex === trackingUpdateIndex) {
			getUpdatedAchievementPopup();
			updateSidebarTopics();
		}
	}).catch(function (e) {
		console.log(e);
	})
}

	const sections = $('article[id]');
	const tocLinks = $('.sidebar-toc .toc-link');

	$('.sidebar-toc').css('top', ($('.toc-box').height() + 170) + 'px');

	function updateActiveTocLink() {
		let currentSection = null;

		sections.each(function() {
			const sectionTop = $(this).offset().top;
			const sectionId = $(this).attr('id');

			if ($(window).scrollTop() >= sectionTop - 150) {
				currentSection = sectionId;
			}
		});

		tocLinks.removeClass('active');
		if (currentSection) {
			const activeLink = $('.toc-link a[href="#' + currentSection + '"]').parent();
			activeLink.addClass('active');

			// Scroll the sidebar menu to keep the active link visible
			scrollToActiveLink();
		}
	}

	function scrollToActiveLink() {
		const tocList = $('.sidebar-toc ul');
		const activeLink = tocList.find('.active');

		if (!activeLink.length || !tocList.hasClass('oflow')) {
			return;
		}

		const tocScrollTop = tocList.scrollTop();
		const tocOffsetTop = tocList.offset().top;
		const tocHeight = tocList.outerHeight();

		const linkOffsetTop = activeLink.offset().top;
		const linkHeight = activeLink.outerHeight();

		const newScrollTop = tocScrollTop + (linkOffsetTop - tocOffsetTop);

		// Scroll the TOC container
		if (linkOffsetTop < tocOffsetTop || linkOffsetTop + linkHeight > tocOffsetTop + tocHeight) {
			tocList.animate({ scrollTop: newScrollTop }, 300);
		}
	}

	$(window).on('scroll', updateActiveTocLink);
	updateActiveTocLink();

	let initialSidebarUlHeight = 0;

	function calculateSidebarHeight() {
		// Calculate and cache the initial height of the sidebar
		initialSidebarUlHeight = $('.sidebar-toc ul').outerHeight() + 160;
	}

	function checkSidebarHeight() {
		const windowHeight = $(window).height();

		if (windowHeight < initialSidebarUlHeight) {
			if (!$('.sidebar-toc ul').hasClass('oflow')) {
				$('.sidebar-toc ul').addClass('oflow');
			}
		} else {
			if ($('.sidebar-toc ul').hasClass('oflow')) {
				$('.sidebar-toc ul').removeClass('oflow');
			}
		}
	}

	$(window).on('resize', checkSidebarHeight);
	calculateSidebarHeight();
	checkSidebarHeight();
});

function setCookieOrder(cookieName, cookieValue, nDays) {
	let today = new Date();
	let expire = new Date();

	if (!nDays)
		nDays=1;

	expire.setTime(today.getTime() + 3600000*24*nDays);
	document.cookie = cookieName+"="+escape(cookieValue) + ";expires="+expire.toGMTString() + "; path=/";
}

function checkAndSetDefaultCookie() {
	let order = getCookie("order_archive");
	if (order == "") {
		setCookieOrder('order_archive', 'recommended', 10);
	}
}

checkAndSetDefaultCookie();

function setCookieOrderArchive(cookieName, cookieValue, nDays) {
	let today = new Date();
	let expire = new Date();

	if (!nDays)
		nDays=1;

	expire.setTime(today.getTime() + 3600000*24*nDays);
	document.cookie = cookieName+"="+escape(cookieValue) + ";expires="+expire.toGMTString() + "; path=/";
}

function setCookieTopic(cookieName, cookieValue, nDays) {
	let today = new Date();
	let expire = new Date();

	if (!nDays)
		nDays=1;

	expire.setTime(today.getTime() + 3600000*24*nDays);
	document.cookie = cookieName+"="+escape(cookieValue) + ";expires="+expire.toGMTString() + "; path=/";
	//getCookie(cookieName);
}

function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

jQuery(document).ready(function ($) {
    let paged = 2;
    let isLoading = false;
	let noMorePosts = false;

	function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return rect.bottom - 200 <= window.innerHeight && rect.top >= 0;
    }

	$('a#submit-a-testimonial').on('click', function () {
        stopFetching = true;
    });

    // Detect scroll to bottom
    $('#load-more-testimonials').on('click', function () {
        if (isLoading || noMorePosts) return;
		isLoading = true;
		// Show loading spinner
		$('#loading-spinner').show();

		$.ajax({
			url: accountingcoach.ajax_url,
			type: 'POST',
			data: {
				action: 'load_more_testimonials',
				paged: paged,
				security: accountingcoach.security,
			},
			success: function (response) {
				$('#loading-spinner').hide();

				if (response === 'no_more_posts') {
                    noMorePosts = true;
                    $('#load-more-testimonials').hide();
                    return;
                }

				$('#testimonial-wrap').append(response);
				paged++;
				isLoading = false;
			},
			error: function () {
				$('#loading-spinner').hide();
				alert('Failed to load more testimonials.');
				isLoading = false;
			}
		});
	});
});
